var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 20.443,
  viewBox: "0 0 23 20.443",
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_Notification",
  "data-name": "Icon/Notification",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Combined_Shape",
  "data-name": "Combined Shape",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path2",
  d: "M6.9,1.959H1.064A1.025,1.025,0,0,1,0,.98,1.025,1.025,0,0,1,1.064,0h20.87A1.025,1.025,0,0,1,23,.98a1.025,1.025,0,0,1-1.065.98H15.418A4.1,4.1,0,0,1,11.16,5.876,4.1,4.1,0,0,1,6.9,1.959Z",
  transform: "translate(0 14.567)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "path4",
  d: "M11.5,0A7.666,7.666,0,0,0,3.833,7.666v6.388H1.066a1.064,1.064,0,1,0,0,2.129H6.9a4.259,4.259,0,1,0,8.517,0h6.518a1.064,1.064,0,1,0,0-2.129H19.166V7.666A7.666,7.666,0,0,0,11.5,0Zm0,1.917a5.756,5.756,0,0,1,5.75,5.75v6.388H5.75V7.666A5.756,5.756,0,0,1,11.5,1.917ZM8.814,16.1H13.5v.087a2.342,2.342,0,1,1-4.684,0Z",
  transform: "translate(0.001)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle",
  transform: "translate(4.448)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path7",
  d: "M7.052,0A7.051,7.051,0,0,1,14.1,7.051v7.757H0V7.051A7.051,7.051,0,0,1,7.052,0Z",
  fill: "none"
}))))));
export { SvgNotificationIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/notificationIcon.9caec8ad620f43c5a1146477a98d3abe.svg";